// extracted by mini-css-extract-plugin
module.exports = {"root":"Mobile_root__4yAzP","text":"Mobile_text__1PXJw","icon":"Mobile_icon__KECs3"};